import { create } from "zustand"

const useAdminActiveRequests = create((set) => ({
  activeRequests: [],
  activeRequestCount: 0, // State variable to hold the count of objects in the array
  loading: true,
  setActiveRequests: (requests) =>
    set({ activeRequests: requests, activeRequestCount: requests.length, loading: false }),
  setActiveRequestLoading: (loadingState) => set({ loading: loadingState }),
}))

export default useAdminActiveRequests
